import { useState, useEffect, useRef, useCallback } from 'react'

export default function ImageSlideshow({ images, fallback, className = '' }) {
  const [current, setCurrent] = useState(0)
  const [fade, setFade] = useState(true)
  const timerRef = useRef(null)
  const pointerStart = useRef(null)

  const urls = Array.isArray(images) ? images : []
  const count = urls.length

  useEffect(() => {
    if (count <= 1) return
    timerRef.current = setInterval(() => {
      setFade(false)
      setTimeout(() => {
        setCurrent(c => (c + 1) % count)
        setFade(true)
      }, 200)
    }, 4000)
    return () => clearInterval(timerRef.current)
  }, [count])

  const goTo = useCallback((idx) => {
    clearInterval(timerRef.current)
    setFade(false)
    setTimeout(() => {
      setCurrent(idx)
      setFade(true)
    }, 150)
  }, [])

  const onPointerDown = (e) => { pointerStart.current = e.clientX }
  const onPointerUp = (e) => {
    if (pointerStart.current === null || count <= 1) return
    const diff = e.clientX - pointerStart.current
    if (Math.abs(diff) > 40) {
      const next = diff < 0 ? (current + 1) % count : (current - 1 + count) % count
      goTo(next)
    }
    pointerStart.current = null
  }

  if (!count) {
    return <div className={`flex items-center justify-center bg-surface-high ${className}`}>{fallback}</div>
  }

  return (
    <div
      className={`relative overflow-hidden bg-surface-high ${className}`}
      onPointerDown={onPointerDown}
      onPointerUp={onPointerUp}
    >
      <img
        src={urls[current]}
        alt=""
        className={`w-full h-full object-cover transition-opacity duration-300 ${fade ? 'opacity-100' : 'opacity-0'}`}
        draggable={false}
      />

      {count > 1 && (
        <div className="absolute bottom-2 left-0 right-0 flex items-center justify-center gap-1.5">
          {urls.map((_, i) => (
            <button
              key={i}
              onClick={(e) => { e.stopPropagation(); goTo(i) }}
              className={`w-1.5 h-1.5 transition-colors ${i === current ? 'bg-terracotta' : 'bg-cream/30'}`}
              aria-label={`Image ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  )
}
